/**
 * @fileOverview This file contains general helper functions
 * @version 1.0.0
 * @since 1.0.0
 * @author Diego Benítez Reyna
 */

/**
 * @summary Method that checks if a value is inside an array of objects based on the index property to be searched.
 * @since 1.0.0
 *
 * @function
 * @param {any} value The value to be searched
 * @param {Array<Object>} array The array where the value is contained
 * @param {string} keyIndex The property that will match the value
 * @returns {Boolean} True if the value exists, False if the value is not found in the array
 */
export const isValueInArray = (value, array, keyIndex) => {
  if (array.length === 0) return false;

  return array.some((item) => item[keyIndex] === value);
};

/**
 * @summary Method that trims the passed string value.
 * @since 1.0.0
 *
 * @function
 * @param {string} value
 * @returns {string} The trimed value
 */
export const trimValue = (value) => value.trim();
